var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg84NotCovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84662",
    "data-name": "Group 84662",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.235,
    height: 80.235,
    viewBox: "0 0 80.235 80.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84655",
    "data-name": "Group 84655"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24670",
    "data-name": "Rectangle 24670",
    width: 2.548,
    height: 2.056,
    transform: "translate(27.493 18.934)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24671",
    "data-name": "Rectangle 24671",
    width: 2.548,
    height: 2.056,
    transform: "translate(41.191 18.934)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240133",
    "data-name": "Path 240133",
    d: "M42.984,24.569H40.929V12.7a2.4,2.4,0,0,0-2.4-2.4H19.185V8.254H38.533A4.455,4.455,0,0,1,42.984,12.7Z",
    transform: "translate(33.895 13.078)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24672",
    "data-name": "Rectangle 24672",
    width: 2.056,
    height: 2.396,
    transform: "translate(74.823 39.942)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240134",
    "data-name": "Path 240134",
    d: "M76.879,52.607V49.589H74.823v2.855H55.163a1.028,1.028,0,0,0-.938.6L52.452,56.99A2.4,2.4,0,0,1,50.266,58.4H29.87a2.4,2.4,0,0,1-2.186-1.411l-1.776-3.943a1.024,1.024,0,0,0-.935-.6H5.309V12.7a2.4,2.4,0,0,1,2.4-2.4H18.153V8.254H7.708A4.455,4.455,0,0,0,3.256,12.7v39.9A4.457,4.457,0,0,0,0,56.893,10.278,10.278,0,0,0,10.267,67.158h59.6a10.278,10.278,0,0,0,10.27-10.265A4.457,4.457,0,0,0,76.879,52.607Z",
    transform: "translate(0 13.078)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240135",
    "data-name": "Path 240135",
    d: "M73,54.484,58.3,29.033a4.477,4.477,0,0,0-7.711,0L48.616,32.45,43.456,29a1.026,1.026,0,0,0-.57-.174H38.578a11.079,11.079,0,0,0,1.453-4.288l1.53-.379a1.027,1.027,0,0,0,.78-1V16.826A1.026,1.026,0,0,0,41.314,15.8h-1.2V13.437h2.57V11.384H41.265A12.166,12.166,0,0,0,28.986.544a12.166,12.166,0,0,0-12.279,10.84H15.288v2.053h2.57V15.8h-1.2a1.026,1.026,0,0,0-1.026,1.026v6.333a1.027,1.027,0,0,0,.78,1l1.533.379a11.06,11.06,0,0,0,1.45,4.288h-4.4a1.028,1.028,0,0,0-.573.174L4.21,35.831a1.034,1.034,0,0,0,.1,1.765l6.311,3.254L3.861,54.542a1.033,1.033,0,0,0,.921,1.48H35.344a4.482,4.482,0,0,0,4.4,5.138h29.4A4.476,4.476,0,0,0,73,54.484ZM19.911,13.437h18.15V15.8H19.911Zm-2.224,8.92v-4.5h22.6v4.5l-6.969,1.726L29.683,20.7a1.026,1.026,0,0,0-1.4,0l-3.635,3.386ZM27.91,53.97H21.953V45.008a1.028,1.028,0,0,0-.559-.913L6.8,36.57l8.068-5.4L27.91,43.946Zm-7.8-28.9,4.584,1.137a1.029,1.029,0,0,0,.949-.246l3.339-3.113,3.339,3.113a1.031,1.031,0,0,0,.949.246l4.59-1.137a9.076,9.076,0,0,1-17.751,0Zm9.855,18.872L43.008,31.169l4.576,3.063-3.4,5.89-7.7,3.973a1.031,1.031,0,0,0-.556.913V53.97h-5.96ZM69.142,59.1h-29.4a2.408,2.408,0,0,1-2.075-3.594l14.7-25.451a2.412,2.412,0,0,1,4.153,0l14.7,25.451c.434.75.805,3.16-2.075,3.594",
    transform: "translate(6.63 -0.544)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240136",
    "data-name": "Path 240136",
    d: "M23.868,26.436l.371-12.674H21.6l.368,12.674Z",
    transform: "translate(38.156 22.808)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240137",
    "data-name": "Path 240137",
    d: "M23.113,19.082a1.625,1.625,0,1,0,0,3.251,1.555,1.555,0,0,0,1.627-1.624,1.539,1.539,0,0,0-1.627-1.627",
    transform: "translate(37.96 32.208)",
    fill: "#ffb164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg84NotCovered);
export default __webpack_public_path__ + "static/media/8.4_Not_Covered.78abdf64d6d56cf53dc6ff62599cf066.svg";
export { ForwardRef as ReactComponent };